import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sga-bar.magic.css.js';
import SgaBarComponent from './sga-bar.js';

const __vue_script__ = SgaBarComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "sga-bar",
      class: { "sga-bar--logout": !_vm.isLoggedIn },
      attrs: {
        part: _vm.$p("sga-bar", { "sga-bar--logout": !_vm.isLoggedIn }),
        "data-v-test-id": "sga-bar"
      }
    },
    [
      _vm.userLoginTime && _vm.isLoggedIn
        ? _c(
            "div",
            { staticClass: "timer", attrs: { part: "timer" } },
            [
              _c("magic-ui-text", {
                staticClass: "text",
                attrs: { part: "text", content: _vm.$t("sga-bar.session") }
              }),
              _vm._v(" "),
              _c("magic-ui-time", {
                staticClass: "time",
                attrs: {
                  "with-seconds": "",
                  part: "time",
                  "data-v-test-id": "sga-bar-time",
                  since: _vm.userLoginTime
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c(
            "div",
            {
              staticClass: "links",
              attrs: { part: "links", "data-v-test-id": "logged-in-sga-bar" }
            },
            [
              _c(
                "magic-ui-link",
                {
                  staticClass: "link",
                  attrs: {
                    part: "link",
                    "data-v-test-id": "sga-bar-24h-exclude",
                    to: _vm.RoutablePage.PANIC_SELF_EXCLUDE
                  }
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      part: "image",
                      src: "/img/icons/24hpaus.svg",
                      title: "24h paus",
                      alt: "24h paus"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "magic-ui-link",
                {
                  staticClass: "link",
                  attrs: {
                    part: "link",
                    "data-v-test-id": "sga-bar-self-exclude",
                    to: _vm.RoutablePage.SELF_EXCLUDE
                  }
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      part: "image",
                      src: "/img/icons/spelpaus.svg",
                      title: "Spelpaus",
                      alt: "Spelpaus"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "magic-ui-link",
                {
                  staticClass: "link",
                  attrs: {
                    part: "link",
                    "data-v-test-id": "sga-bar-limits",
                    to: _vm.RoutablePage.RESPONSIBLE_GAMING
                  }
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      part: "image",
                      src: "/img/icons/spelgranser.svg",
                      title: "Spelgränser",
                      alt: "Spelgränser"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "links",
              attrs: { part: "links", "data-v-test-id": "logged-out-sga-bar" }
            },
            [
              _c(
                "magic-ui-link",
                {
                  staticClass: "link",
                  attrs: {
                    part: "link",
                    to: _vm.RoutablePage.PANIC_SELF_EXCLUDE
                  }
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      part: "image",
                      src: "/img/icons/24hpaus.svg",
                      title: "24h paus",
                      alt: "24h paus"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "magic-ui-link",
                {
                  staticClass: "link",
                  attrs: {
                    part: "link",
                    to: _vm.RoutablePage.RESPONSIBLE_GAMING
                  }
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      part: "image",
                      src: "/img/icons/spelgranser.svg",
                      title: "Spelgränser",
                      alt: "Spelgränser"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(2)
            ],
            1
          )
    ]
  )
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "a",
      {
        staticClass: "link",
        attrs: {
          href: "https://www.stodlinjen.se/#!/spelberoende-test-pgsi",
          part: "link",
          "data-v-test-id": "sga-bar-self-test",
          target: "_blank",
          rel: "noopener noreferrer"
        }
      },
      [
        _c("img", {
          staticClass: "image",
          attrs: {
            part: "image",
            src: "/img/icons/sjalvtest.svg",
            title: "Självtest",
            alt: "Självtest"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "a",
      {
        staticClass: "link",
        attrs: {
          href:
            "https://www.spelpaus.se/sa-har-fungerar-det/om-webbplatsen/redirect",
          part: "link",
          target: "_blank",
          rel: "noopener noreferrer"
        }
      },
      [
        _c("img", {
          staticClass: "image",
          attrs: {
            part: "image",
            src: "/img/icons/spelpaus.svg",
            title: "Spelpaus",
            alt: "Spelpaus"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "a",
      {
        staticClass: "link",
        attrs: {
          href: "https://stodlinjen.se/spelberoende-test-pgsi",
          part: "link",
          target: "_blank",
          rel: "noopener noreferrer"
        }
      },
      [
        _c("img", {
          staticClass: "image",
          attrs: {
            part: "image",
            src: "/img/icons/sjalvtest.svg",
            title: "Självtest",
            alt: "Självtest"
          }
        })
      ]
    )
  }
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-08c0aefe_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-08c0aefe";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
